import React, { useState } from "react";
import BlockMapper from "modules/forms/embedded/blocks/BlockMapper";
import useHttp from "components/hooks/useHttp";
import useToast from "components/hooks/useToast";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { asFormData } from "core/helpers";
import useForm from "modules/forms/hooks/useForm";
import useRouting from "hooks/useRouting";
import useReCaptcha from "modules/forms/components/recaptcha/useReCaptcha";
import ReCaptcha from "modules/forms/components/recaptcha/ReCaptcha";

export default function CustomPage() {
    const { push } = useRouting();
    const { onSubmit, onError, form } = useForm();
    const { values, setContact, setIsSubmitting } = useFormFlow();
    const { errorToast, successToast } = useToast();
    const apiUrl = `/forms/${form.uuid}/public/submit`;
    const http = useHttp();
    const recaptchaRef = useReCaptcha();
    const customPages = form.pages.filter(p => p.type == "custom");
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const currentPage = customPages[currentPageIndex];
    const nextPage = customPages[currentPageIndex + 1];

    const submit = async () => {
        setIsSubmitting(true);

        if (!nextPage) {

            const recaptchaToken = await recaptchaRef.current.executeAsync();
            const formData = asFormData(values);

            try {
                onSubmit(formData);
            } catch (error) {
                console.error("Could not submit custom on submit", error);
            }

            http.withCaptcha(recaptchaToken)
                .post(apiUrl, formData)
                .then((res) => {
                    const data = res.data.data;
                    setContact(data.contact);
                    successToast();
                    push(`/forms/${form.uuid}/public/custom-success`);
                })
                .catch(e => {
                    errorToast(e);
                    onError(e);
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            setIsSubmitting(false);
            setCurrentPageIndex(prevState => prevState + 1);
        }
    };

    return (
        <form
            id={form.uuid}
            onSubmit={e => {
                e.preventDefault();
                submit();
            }}
        >
            {currentPage.blocks.map(block => (
                <BlockMapper
                    key={block.uuid}
                    block={block}
                />
            ))}

            <ReCaptcha captchaRef={recaptchaRef} hideBadge={false}/>
        </form>
    );
}
